// Firestore path helpers for ticket pools and redemptions

export function poolDocPath(subkreweId: string, year: string): string {
  return `subkrewes/${subkreweId}/ticket_pools/${year}`
}

export function poolTicketsCollectionPath(subkreweweId: string, year: string): string {
  return `${poolDocPath(subkreweweId, year)}/tickets`
}

export function poolTicketDocPath(subkreweId: string, year: string, ticketId: string): string {
  return `${poolTicketsCollectionPath(subkreweId, year)}/${ticketId}`
}

export function ticketPoolRedemptionsCollection(): string {
  return 'ticket_pool_redemptions'
}
